import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import ReactHtmlParser, { processNodes } from 'react-html-parser';

const MAIN_CLASS = 'offerDetails-tab';

const Details = ({ offerDetails }) => {
  const {
    content: { total, breakfast },
  } = offerDetails;

  function transform(node, index) {
    if (node.type === 'tag' && node.name === 'a') {
      return <React.Fragment key={index}>{processNodes(node.children, transform)}</React.Fragment>;
    }

    return undefined;
  }

  const options = {
    decodeEntities: true,
    transform,
  };

  return (
    <div className="popin-condition__content">
      <div className={`${MAIN_CLASS}-tab popin-tabs`}>
        <div className={`${MAIN_CLASS}__hd`}>
          <span className={`${MAIN_CLASS}__left`}>{total.title}</span>
          <span className={`${MAIN_CLASS}__right`}>{total.total}</span>
        </div>

        <div className={`${MAIN_CLASS}__container`}>
          {total.duration.map((item) => {
            return (
              <div className={`${MAIN_CLASS}__fl`} key={uuidv4()}>
                <span className={`${MAIN_CLASS}__left grey`}>{item.value}</span>
                <span className={`${MAIN_CLASS}__right`}>{item.amount}</span>
              </div>
            );
          })}

          { total.description && (
            <div className="large-rates__club-title">
              <div className="ico" />
              { total.description?.club?.title}
            </div>
          )}

          { total.description && (
            <p className="large-rates__sub-title">
              {ReactHtmlParser(total.description?.value, options)}
            </p>
          )}
        </div>

        <div className={`${MAIN_CLASS}__hd`}>
          <span className={`${MAIN_CLASS}__left`}>{breakfast.title}</span>
          <span className={`${MAIN_CLASS}__right`}>{breakfast.total}</span>
        </div>

        <div className={`${MAIN_CLASS}__container`}>
          {breakfast.duration.map((item) => {
            return (
              <div className={`${MAIN_CLASS}__fl`} key={uuidv4()}>
                <span className={`${MAIN_CLASS}__left grey`}>{item.value}</span>
                <span className={`${MAIN_CLASS}__right`}>{item.amount}</span>
              </div>
            );
          })}

          {breakfast.meal_description && <p>{breakfast.meal_description}</p>}

          {breakfast.tax.included && (
            <>
              <h5>{breakfast.tax.included.label}</h5>
              {breakfast.tax.included.value.map((item) => (
                <p key={uuidv4()}>{item}</p>
              ))}
            </>
          )}

          {breakfast.tax.not_included && (
            <>
              <h5>{breakfast.tax.not_included.label}</h5>
              {breakfast.tax.not_included.value.map((item) => (
                <p key={uuidv4()}>{item}</p>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Details;
